import { alpha } from "@material-ui/core/styles";
import styled from "styled-components";
import { StyledDialog } from "../../Customization/CommonElements";
import { theme } from "../../Customization/Theme";

export const LeftMenuWrap = styled.div`
  && {
    color: ${theme.palette.default.white};
    padding: 0.7rem 8px 0.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
  img {
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: block;
  }
  .leftTopMenu {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    height: 100%;
     .menuItem {
      .menuButton {
        padding: 12px;
        border-radius: 4px;
        // font-size: 10px;
        // display: flex;
        // flex-direction: column;
        // gap: 8px;
      }
    } 

    /* .MuiListItem-root{
      padding-left:0px;
      padding-right:0px;
    } */
  }
  .leftMenuWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: 1rem;
  }

  .MuiList-root{
    width: 64px;
    height: 100%;
  }

  .MuiListItem-root{
    padding:4px;
  }

  .menuButton {
        border-radius: 4px;
        font-size: 9px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        gap: 6px;
      }

  .anchor-link{
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    max-width: 64px;
    padding: 4px 2px;
    border-radius: 6px;
    margin: 4px;
    margin-bottom: 8px;
  }

  .anchor-text{
    font-size: 10px;
    text-align: center;
    line-height: 1.2;
  }

  .logoBox{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
  }
}

`;

export const MenuStyles = styled.div`
  position: absolute;
  top: 40px;
  left: 4.5rem;
  border: 2px solid white;
  background: red;
  transform: translateY(-50%);
  background: ${({ theme }: any) => theme.palette.primary.main};
  width: 200px;
  padding: 12px 0;
  border-radius: 8px;
  z-index: 9999 !important ;
  svg {
    max-width: 13px;
    max-height: 13px;
    margin-right: 5px;
  }
  .listItem {
    padding: 6px 12px;
    font-size: 14px;
    line-height: 21px;
    color: ${alpha(theme.palette.default.white, 1)};
    display: flex;
    justify-content: flex-start;
    &:hover,
    .active {
      color: ${alpha(theme.palette.primary.contrastText, 1)};
    }
  }
`;

export const HelpMenuStyles = styled.div`
  position: absolute;
  top: 15px;
  left: 4.5rem;
  border: 2px solid white;
  background: red;
  transform: translateY(-50%);
  background: ${({ theme }: any) => theme.palette.primary.main};
  width: 200px;
  padding: 12px 0;
  border-radius: 8px;
  z-index: 9999 !important ;
  svg {
    max-width: 13px;
    max-height: 13px;
    margin-right: 5px;
  }
  .listItem {
    padding: 6px 12px;
    font-size: 14px;
    line-height: 21px;
    color: ${alpha(theme.palette.default.white, 1)};
    display: flex;
    justify-content: flex-start;
    &:hover,
    .active {
      color: ${alpha(theme.palette.default.white, 1)};
    }
  }
`

export const Wallet = styled.div`
  & {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 14px;
    color: ${theme.palette.default.darkGrey};
    .creditsTitle {
      width: 15rem;
    }
    p span.credits {
      color: ${theme.palette.default.black};
      font-weight: 400;
      font-size: 14px;
    }
  }
`;

export const StyledWalletDialog = styled(StyledDialog)`
  .walletHeader {
  }
  .walletTitle {
    color: #101010;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
    .walletInput {
      width: 500px !important;
      margin: 13px 0px !important;
    }
  }
  .walletValue {
    border-radius: 33px !important;
    border: 1px solid #c5cfff !important;
    background: #eef1ff !important;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    color: #5b73e8 !important;
    margin: 0px 4px !important;
  }
  .walletCondition {
    border-radius: 4px;
    border: 1px solid #cbcdd3;
    padding: 3px 11px;
  }
  .walletValues {
    display: flex;
  }
`;
export const BroadcastText = styled.p`
  color: #101010;
  
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin: 20px 0px 12px;
`;
export const BroadcastInfo = styled.div`
  color: #7e8392;
  
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  display: flex;
`;
export const actionIson = {
  fontSize: "10px",
  margin: "10px 5px",
};
